import React, {FC, useEffect, useRef, useState} from "react";
import {t} from "i18next";
import { useAppDispatch, useAppSelector } from "../../hooks";
import { changeInvoiceDetails } from "../../stateReducers/invoiceSlice";
import TextInputField from "./TextInputField";
import Checkbox from "./Checkbox";
import { useTranslation } from "react-i18next";
import SelectInput from "./SelectInput";

interface InvoiceProps {
    highlightField: (key: string) => boolean
}

export const InvoiceForm: FC<InvoiceProps> = ({
    highlightField
}) => {
    const invoiceDetails = useAppSelector((state) => { return state.invoiceDetails; });
    const d = useAppDispatch();
    const {t} = useTranslation();

    return (
        <>
            {/* Name of organization */}
            <TextInputField
                value={invoiceDetails.nameOfOrganization}
                label={'nameOfOrganization'}
                labelText={t('invoice.nameOfOrganization')}
                onChange={(e) => { d(changeInvoiceDetails({ nameOfOrganization: e.target.value })); } }
                required={true}
                additionalNote={t('invoice.warning')}
                placeholder={t('invoice.nameOfOrganization')}
                redHighlight={highlightField('nameOfOrganization')}
            />

            {/* Invoice e-mail */}
            <TextInputField
                value={invoiceDetails.invoiceEmail}
                label={'invoiceEmail'}
                labelText={t('invoice.invoiceEmail')}
                onChange={(e) => { d(changeInvoiceDetails({ invoiceEmail: e.target.value })); } }
                required={true}
                placeholder={t('invoice.invoiceEmail')}
                redHighlight={highlightField('invoiceEmail')}
            />

            {/* Tax number */}
            <TextInputField
                value={invoiceDetails.taxNumber}
                label={'taxNumber'}
                labelText={t('invoice.taxNumber')}
                onChange={(e) => { d(changeInvoiceDetails({ taxNumber: e.target.value })); } }
                required={false}
                placeholder={t('invoice.taxNumber')}
                redHighlight={highlightField('taxNumber')}
            />

            {/* Street */}
            <TextInputField
                value={invoiceDetails.street}
                label={'street'}
                labelText={t('invoice.street')}
                onChange={(e) => { d(changeInvoiceDetails({ street: e.target.value })); } }
                required={true}
                placeholder={t('invoice.street')}
                redHighlight={highlightField('street')}
            />

            {/* House number */}
            <TextInputField
                value={invoiceDetails.houseNumber}
                label={'houseNumber'}
                labelText={t('invoice.houseNumber')}
                onChange={(e) => { d(changeInvoiceDetails({ houseNumber: e.target.value })); } }
                required={true}
                placeholder={t('invoice.houseNumber')}
                redHighlight={highlightField('houseNumber')}
            />

            {/* Postcode postcode */}
            <TextInputField
                value={invoiceDetails.postcode}
                label={'postcode'}
                labelText={t('invoice.postcode')}
                onChange={(e) => { d(changeInvoiceDetails({ postcode: e.target.value })); } }
                required={true}
                placeholder={t('invoice.postcode')}
                redHighlight={highlightField('postcode')}
            />

            {/* City */}
            <TextInputField
                value={invoiceDetails.city}
                label={'city'}
                labelText={t('invoice.city')}
                onChange={(e) => { d(changeInvoiceDetails({ city: e.target.value })); } }
                required={true}
                placeholder={t('invoice.city')}
                redHighlight={highlightField('city')}
            />

            {/* Country selection */}

            <SelectInput
                value={invoiceDetails.country ?? 'Belgium'}
                options={{
                    'Belgium': t('invoice.Belgium'),
                    'Netherlands': t('invoice.Netherlands'),
                    'France': t('invoice.France')
                }}
                label={'country'}
                labelText={t('invoice.countrySelection')}
                onChange={(e) => {
                    d(changeInvoiceDetails({country: e.target.value}));
                }}
                required={true}
                redHighlight={highlightField('country')}
            />

            {/* Order form checkbox */}
            <div className="form-group mb-2 flex flex-row">
                <Checkbox
                        checked={invoiceDetails.orderForm ?? false}
                        label="orderForm"
                        labelText={`${t('invoice.orderForm')} (${t('invoice.orderFormExplanation')})`}
                        // @ts-ignore
                        onChange={(e) => d(changeInvoiceDetails({orderForm: e.target.checked}))}
                        required={false}
                        redHighlight={highlightField('orderForm')}
                />
            </div>
            
            {/* Have order form number */}
            {invoiceDetails.orderForm &&
                <SelectInput
                    value={invoiceDetails.haveOrderFormNumber ?? 'No'}
                    options={{
                        'Yes': t('invoice.yesOrderFormNumber'),
                        'No': t('invoice.noOrderFormNumber')
                    }}
                    label={'haveOrderFormNumber'}
                    labelText={t('invoice.haveOrderFormNumber')}
                    onChange={(e) => {
                        d(changeInvoiceDetails({haveOrderFormNumber: e.target.value}));
                    }}
                    required={true}
                    redHighlight={highlightField('haveOrderFormNumber')}
                />
            }
            
            {/* Order form number field */}
            {invoiceDetails.haveOrderFormNumber === "Yes" &&
                <TextInputField
                    value={invoiceDetails.orderFormNumber}
                    label={'orderFormNumber'}
                    labelText={t('invoice.orderFormNumber')}
                    onChange={(e) => { d(changeInvoiceDetails({ orderFormNumber: e.target.value })); } }
                    required={true}
                    placeholder={t('invoice.orderFormNumber')}
                    redHighlight={highlightField('orderFormNumber')}
                />
            }

            {/* Comments */}
            <TextInputField
                value={invoiceDetails.comments}
                label={'comments'}
                labelText={t('invoice.comments')}
                onChange={(e) => { d(changeInvoiceDetails({ comments: e.target.value })); } }
                required={false}
                placeholder={t('invoice.comments')}
                redHighlight={highlightField('comments')}
            />
            
        </>

    );
}